// "Uncovered Video Log" reward items — a fixed, curated set of short mood
// clips scattered across missions as rewards (see configs/static_data.json
// items 8-21 and each mission's `rewards` array). Item ids are the single
// point of coupling: this table and the static_data.json item entries must
// agree on which id maps to which clip. There's no server round-trip for
// this — the catalog is small and hand-authored, so it's simpler to keep it
// here than to build a sync protocol for content that never changes at
// runtime. If the roster grows a lot, consider shipping this list from the
// server instead.
export interface VideoLogEntry {
  title: string;
  file: string;
}

export const VIDEO_LOG_ITEMS: Record<number, VideoLogEntry> = {
  8: { title: "THE IDLE", file: "Car_dashboard_glows_in_parking_202608051802.mp4" },
  9: { title: "IDLING ROW", file: "Six_vans_parked_at_dawn_202608051802.mp4" },
  10: { title: "THE DIAGNOSTIC BYTE", file: "Hands_typing_on_glowing_monitors_202608051802.mp4" },
  11: { title: "BUS SHELTER", file: "Figure_tracing_graffiti_on_shelter_202608051802.mp4" },
  12: { title: "THE WALL OF STRING", file: "Character_connects_clues_on_board_202608061002.mp4" },
  13: { title: "SIGNAL LOSS", file: "Traffic_control_room_city_grid_202608051802.mp4" },
  14: { title: "THE EMPTY RAIL YARD", file: "Freight_rail_yard_at_golden_202608051802.mp4" },
  15: { title: "TICKER", file: "Trader_watching_falling_numbers_202608051802.mp4" },
  16: { title: "HANDOFF", file: "Two_figures_meeting_under_light_202608051801.mp4" },
  17: { title: "FIRST RESPONDERS", file: "Car_wreck_with_flashing_lights_202608051802.mp4" },
  18: { title: "OBD PORT", file: "Mechanic_holding_scanner_car_202608051801.mp4" },
  19: { title: "RAIN ON CHROME", file: "Figure_walking_on_walkway_202608051802.mp4" },
  20: { title: "OVERPASS CONVOY", file: "Driverless_cars_on_highway_202608051802.mp4" },
  21: { title: "THE NAME ALMOST SAID", file: "Server_room_blinking_equipment_202608061044.mp4" },
};

export const VIDEO_LOG_BASE_PATH = "/assets/video/challenge/";
